import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { DataSource } from "src/app/shared/models/enums/data-source.enum";
import { OOCanvas } from "src/app/shared/models/oo-canvas";
import { OOMenuItem } from "src/app/shared/models/oo-menu-item";
import { OOMenuItemCanvas } from "src/app/shared/models/oo-menu-item-canvas.model";

@Component({
	selector: "app-menu-item-modifier-view",
	templateUrl: "./menu-item-modifier-view.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class MenuItemModifierViewComponent implements OnInit, OnDestroy {
	@Input() canvasList: OOCanvas[];
	@Input() menuItem: OOMenuItem;
	@Input() ooMenuItemCanvases: OOMenuItemCanvas[];
	@Input() venueKey: number;

	ooMenuItemCanvasSelected: OOMenuItemCanvas;
	newOoMenuItemCanvas: boolean = false;

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueSvc: OOVenueService) {}

	ngOnInit(): void {
		if (this.ooMenuItemCanvases) {
			this.ooMenuItemCanvases = this.venueSvc.sortForDisplay(this.ooMenuItemCanvases);
		}
	}

	ngOnDestroy() {}

	ooMenuItemCanvasNew() {
		this.newOoMenuItemCanvas = true;
		this.ooMenuItemCanvasSelected = new OOMenuItemCanvas({
			venueKey: this.venueKey,
			menuItemKey: this.menuItem.menuItemKey,
			source: DataSource.COMMANDCENTER,
		});
	}

	async ooMenuItemCanvasRemove(rec: OOMenuItemCanvas) {
		this.app.confirmation.confirm({
			message: `Are you sure you want to remove ${rec.ooCanvas.displayName || rec.ooCanvas.name} from ${
				this.menuItem.displayName || this.menuItem.name
			}?`,
			accept: async () => {
				this.focuslink.menuItemCanvasDelete(this.venueKey, rec.menuItemKey, rec.canvasKey);
				const idx = this.ooMenuItemCanvases.findIndex((i) => i.canvasKey === rec.canvasKey);
				this.ooMenuItemCanvases.splice(idx, 1);
				this.onCanvasReorder();
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	async ooMenuItemCanvasSave(rec: OOMenuItemCanvas | OOMenuItemCanvas[]) {
		if (Array.isArray(rec)) {
			rec.forEach((i) => {
				i.includedItemCanvas ? this.venueSvc.ooCanvases.find((canvas) => canvas.canvasKey === i.canvasKey).includedItemCanvas : false;
			});
		} else {
			rec.includedItemCanvas = this.venueSvc.ooCanvases.find((canvas) => canvas.canvasKey === rec.canvasKey).includedItemCanvas;
		}
		const menuItemKey = Array.isArray(rec) ? rec[0].menuItemKey : rec.menuItemKey;

		this.focuslink.menuItemCanvasPost(this.venueKey, menuItemKey, rec);
		if (this.newOoMenuItemCanvas && !Array.isArray(rec)) {
			rec.ooCanvas = this.canvasList.find((i) => i.canvasKey === rec.canvasKey);
			this.ooMenuItemCanvases.push(rec);
		}
		this.newOoMenuItemCanvas = false;
	}

	onCanvasReorder() {
		try {
			this.ooMenuItemCanvases.forEach((canvas, idx) => {
				canvas.sortOrder = idx;
				const existIdx = this.canvasList.findIndex((i) => i.canvasKey === canvas.canvasKey);
				this.canvasList[existIdx].sortOrder = idx;
			});

			this.focuslink.menuItemCanvasPost(this.venueKey, this.menuItem.menuItemKey, this.ooMenuItemCanvases);
			this.ooMenuItemCanvases = this.venueSvc.sortForDisplay(this.ooMenuItemCanvases);
		} catch (error) {}
	}
}
